import { useInfiniteQuery, useMutation, useQuery } from 'react-query';

import { useServiceError } from '@/hooks';

import { SearchCfopsQuery } from './Cfop.types';
import { cfopDetail, searchCfops } from './Cfop.service';

import { DEFAULT_ORDER, DEFAULT_ROWS } from '..';
import notificationError from '@/utils/functions/notificationError';
import { queryClient } from '@/Root';

export function useCfops(params?: SearchCfopsQuery, enabled = true) {
  const cache = queryClient.getQueryData(['cfops', { ...params }]);

  return useInfiniteQuery(
    ['cfops', { ...params }],
    ({ pageParam }) => {
      const req: SearchCfopsQuery = {
        nextToken: pageParam,
        order: params?.order || DEFAULT_ORDER,
        rows: params?.rows || DEFAULT_ROWS,
        ...params,
      };

      return searchCfops(req);
    },
    {
      getNextPageParam: (lastPage) => lastPage.nextToken,
      enabled: enabled && !cache,
      onError(error) {
        notificationError(error);
      },
    },
  );
}

export function useCfop(id?: number) {
  const query = useQuery(
    ['cfopDetail', id],
    () => (id ? cfopDetail(id) : undefined),
    { enabled: !!id },
  );

  useServiceError(query.error);

  return query;
}

export function useCfopMutation() {
  return useMutation(cfopDetail, {
    onError(error) {
      notificationError(error);
    },
  });
}
